var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipText),expression:"tooltipText"}]},[_c('s-chip',{attrs:{"color":_vm.chipColor}},[_vm._v("\n    "+_vm._s(_vm.statusText)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }